const SVG_NS = "http://www.w3.org/2000/svg";

let gradientCounter = 0;

export interface CornerOptions {
  readonly size?: number;
}

export function createCornerOrnament(options: CornerOptions = {}): SVGSVGElement {
  const size = options.size ?? 38;
  const id = `brass-grad-${gradientCounter++}`;

  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("width", String(size));
  svg.setAttribute("height", String(size));
  svg.setAttribute("viewBox", "0 0 40 40");
  svg.style.display = "block";

  const defs = document.createElementNS(SVG_NS, "defs");
  const grad = document.createElementNS(SVG_NS, "linearGradient");
  grad.setAttribute("id", id);
  grad.setAttribute("x1", "0");
  grad.setAttribute("y1", "0");
  grad.setAttribute("x2", "1");
  grad.setAttribute("y2", "1");

  const stops = [
    { offset: "0%", varName: "--brass-hi" },
    { offset: "50%", varName: "--brass" },
    { offset: "100%", varName: "--brass-deep" },
  ];
  for (const s of stops) {
    const stop = document.createElementNS(SVG_NS, "stop");
    stop.setAttribute("offset", s.offset);
    stop.setAttribute("stop-color", `var(${s.varName})`);
    grad.appendChild(stop);
  }
  defs.appendChild(grad);
  svg.appendChild(defs);

  const g = document.createElementNS(SVG_NS, "g");
  g.setAttribute("fill", "none");
  g.setAttribute("stroke", `url(#${id})`);
  g.setAttribute("stroke-width", "1.2");
  g.setAttribute("stroke-linecap", "round");

  const paths = [
    "M2 2 L2 18 M2 2 L18 2",
    "M2 14 Q8 14 8 8 Q8 4 12 4",
    "M14 14 Q18 14 18 10",
  ];
  for (const d of paths) {
    const p = document.createElementNS(SVG_NS, "path");
    p.setAttribute("d", d);
    g.appendChild(p);
  }
  const dot = document.createElementNS(SVG_NS, "circle");
  dot.setAttribute("cx", "8");
  dot.setAttribute("cy", "8");
  dot.setAttribute("r", "1.6");
  dot.setAttribute("fill", "var(--brass)");
  g.appendChild(dot);

  svg.appendChild(g);
  return svg;
}
